import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Result, UseCase, Guard } from '@digibricks/domains';
import { AnswerType } from '../../../domain';
export var GRADING_ANSWER_USE_CASE = 'GRADING_ANSWER_USE_CASE';
export var GradingAnswerUseCase = /*#__PURE__*/function (_UseCase) {
  _inherits(GradingAnswerUseCase, _UseCase);

  var _super = _createSuper(GradingAnswerUseCase);

  function GradingAnswerUseCase(submissionRepository) {
    var _this;

    _classCallCheck(this, GradingAnswerUseCase);

    _this = _super.call(this);
    _this.submissionRepository = submissionRepository;
    return _this;
  }

  _createClass(GradingAnswerUseCase, [{
    key: "validate",
    value: function validate(useCaseInput) {
      console.log('[grading use case] input:', useCaseInput);
      var collection = [{
        argument: useCaseInput.submissionId,
        argumentName: 'Submission Id'
      }, {
        argument: useCaseInput.input,
        argumentName: 'Input'
      }, {
        argument: useCaseInput.answers,
        argumentName: 'Answer List'
      }, {
        argument: useCaseInput.attendee,
        argumentName: 'Submission Attendee'
      }, {
        argument: useCaseInput.id,
        argumentName: 'Answer Id'
      }, {
        argument: useCaseInput.assignment,
        argumentName: 'Assignment'
      }];
      var guardResult = Guard.againstNullOrUndefinedBulk(collection);

      if (!guardResult.succeeded) {
        return Result.fail(guardResult.message);
      }

      return Result.ok();
    }
  }, {
    key: "buildUseCase",
    value: function () {
      var _buildUseCase = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(useCaseInput) {
        var _assignment$formRelea;

        var resultOrError, input, answers, attendee, submissionId, id, assignment, score, updateAnswerUseCaseInput, updateAnswerOrError, submission, updatedAnswer, i, answer, fillInBlankGroupAnswer, fillInBlankAnswer, matchingAnswerGroup, matching, answerItem, submissionResult, totalScore, scorePercentage, isSubmissionPassed, _fillInBlankGroupAnswer, _matchingAnswerGroup;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                resultOrError = this.validate(useCaseInput);

                if (!resultOrError.isFailure) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return", Result.fail(resultOrError.error));

              case 3:
                input = useCaseInput.input, answers = useCaseInput.answers, attendee = useCaseInput.attendee, submissionId = useCaseInput.submissionId, id = useCaseInput.id, assignment = useCaseInput.assignment;
                score = input.score;
                updateAnswerUseCaseInput = {
                  submissionId: submissionId,
                  id: id,
                  input: {
                    score: score
                  }
                };
                _context.next = 8;
                return this.submissionRepository.updateAnswer(updateAnswerUseCaseInput);

              case 8:
                updateAnswerOrError = _context.sent;

                if (!updateAnswerOrError.isFailure) {
                  _context.next = 11;
                  break;
                }

                return _context.abrupt("return", Result.fail(updateAnswerOrError.error));

              case 11:
                submission = updateAnswerOrError.getValue();
                i = 0;

              case 13:
                if (!(i < answers.length)) {
                  _context.next = 33;
                  break;
                }

                answer = answers[i];
                _context.t0 = answer.type;
                _context.next = _context.t0 === AnswerType.FillInBlank ? 18 : _context.t0 === AnswerType.Matching ? 22 : 26;
                break;

              case 18:
                fillInBlankGroupAnswer = answer;
                fillInBlankAnswer = fillInBlankGroupAnswer.answers.find(function (a) {
                  return a.id.toString() === id;
                });

                if (fillInBlankAnswer) {
                  updatedAnswer = fillInBlankAnswer;
                }

                return _context.abrupt("break", 28);

              case 22:
                matchingAnswerGroup = answer;
                matching = matchingAnswerGroup.answers.find(function (a) {
                  return a.id.toString() === id;
                });

                if (matching) {
                  updatedAnswer = matching;
                }

                return _context.abrupt("break", 28);

              case 26:
                answerItem = answer;

                if (answerItem.id.toString() === id) {
                  updatedAnswer = answerItem;
                }

              case 28:
                if (!updatedAnswer) {
                  _context.next = 30;
                  break;
                }

                return _context.abrupt("break", 33);

              case 30:
                i++;
                _context.next = 13;
                break;

              case 33:
                submissionResult = submission.result; // Calculate isSubmissionPassed based on score percentage vs assignment expectation

                totalScore = ((_assignment$formRelea = assignment.formReleaseInformation) === null || _assignment$formRelea === void 0 ? void 0 : _assignment$formRelea.totalScore) || 1;
                scorePercentage = submissionResult.score / totalScore * 100;
                isSubmissionPassed = scorePercentage >= assignment.expectation;
                attendee.updateReport({
                  score: submissionResult.score,
                  gradedPercentage: submissionResult.gradedPercentage.value,
                  isSubmissionPassed: isSubmissionPassed
                });
                updatedAnswer.updateScore(score);
                _context.t1 = updatedAnswer.type;
                _context.next = _context.t1 === AnswerType.FillInBlank ? 42 : _context.t1 === AnswerType.Matching ? 45 : 48;
                break;

              case 42:
                _fillInBlankGroupAnswer = answers.find(function (answer) {
                  return answer.questionId === updatedAnswer.questionId;
                });

                _fillInBlankGroupAnswer.updateAnswers(updatedAnswer);

                return _context.abrupt("return", Result.ok({
                  updatedAnswer: _fillInBlankGroupAnswer,
                  updatedAttendee: attendee
                }));

              case 45:
                _matchingAnswerGroup = answers.find(function (answer) {
                  return answer.questionId === updatedAnswer.questionId;
                });

                _matchingAnswerGroup.updateAnswers(updatedAnswer);

                return _context.abrupt("return", Result.ok({
                  updatedAnswer: _matchingAnswerGroup,
                  updatedAttendee: attendee
                }));

              case 48:
                return _context.abrupt("return", Result.ok({
                  updatedAnswer: updatedAnswer,
                  updatedAttendee: attendee
                }));

              case 49:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function buildUseCase(_x) {
        return _buildUseCase.apply(this, arguments);
      }

      return buildUseCase;
    }()
  }]);

  return GradingAnswerUseCase;
}(UseCase);